import React, { ReactElement } from 'react';
import FormFieldText from '../form-field-text/form-field-text.component';
import FormFieldPassword from '../form-field-password/form-field-password.component';
import FlexContainer from '../flex-container/flex-container.component';
import ActionButton from '../action-button/action-button.component';
import CopyIcon from '../../icons/copy-icon';
import RefreshKeyIcon from '../../icons/refresh-key-icon';
import FormatService from '../../services/format-service';
import useStylesSecretKeyBlock from './secret-key-block.styles';

const SecretKeyBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEditMode,
    isSecretKeyChanged,
    secretKeyValue,
    secretKeyFormFieldName,
    onGetSecretKey,
    onCopySecretKey,
  } = props;

  const { classes } = useStylesSecretKeyBlock();

  return (
    <FlexContainer>
      {
        isEditMode ? (
          <FlexContainer className={classes.secretKeyBlockFieldContainer}>
            {
              isSecretKeyChanged ? (
                <FormFieldText isBordered isDisabled name={secretKeyFormFieldName} />
              ) : (
                <FormFieldPassword isBordered isDisabled withNoAutocomplete name={secretKeyFormFieldName} />
              )
            }
          </FlexContainer>
        ) : (
          <FlexContainer
            className={FormatService.formatClassNames(
              classes.secretKeyBlockFieldContainer, classes.secretKeyBlockFieldContainerHidden,
            )}
          >
            {(!!secretKeyValue && FormatService.formatEncryptedString(secretKeyValue)) || ''}
          </FlexContainer>
        )
      }
      <FlexContainer isInline>
        {
          !!secretKeyValue && (
            <div>
              <ActionButton withPopup onClick={onCopySecretKey}>
                <CopyIcon />
              </ActionButton>
            </div>
          )
        }
        {
          isEditMode && (
            <div>
              <ActionButton withPopup onClick={onGetSecretKey}>
                <RefreshKeyIcon />
              </ActionButton>
            </div>
          )
        }
      </FlexContainer>
    </FlexContainer>
  );
});

export default SecretKeyBlock;
